import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8ee2fcc4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "notification-wrapper" }
const _hoisted_2 = { class: "notification-list" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "notification-list__title" }, " Notificações ", -1))
const _hoisted_4 = {
  key: 0,
  class: "notification-default"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NotificationItem = _resolveComponent("NotificationItem")!
  const _component_ConfirmationModal = _resolveComponent("ConfirmationModal")!
  const _component_NotificationModal = _resolveComponent("NotificationModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("ul", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notifications, (notification, index) => {
          return (_openBlock(), _createBlock(_component_NotificationItem, {
            key: index,
            notification: notification,
            onClick: ($event: any) => (_ctx.goToNotification(notification)),
            onDelete: ($event: any) => (_ctx.openConfirmation(notification.id))
          }, null, 8, ["notification", "onClick", "onDelete"]))
        }), 128)),
        (!_ctx.notifications.length)
          ? (_openBlock(), _createElementBlock("li", _hoisted_4, " Você não possui nenhuma notificação "))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_ConfirmationModal, {
        isOpen: _ctx.showConfirmation,
        message: "Deseja realmente apagar essa notificação?",
        confirmButtonText: "Apagar",
        cancelButtonText: "Cancelar",
        onConfirm: _ctx.confirmDelete,
        onCancel: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showConfirmation = false))
      }, null, 8, ["isOpen", "onConfirm"])
    ], 512), [
      [_vShow, _ctx.isOpened]
    ]),
    (_ctx.showNotificationModal)
      ? (_openBlock(), _createBlock(_component_NotificationModal, {
          key: 0,
          isOpen: _ctx.showNotificationModal,
          notificationID: _ctx.selectedNotificationID,
          onToggle: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showNotificationModal = false))
        }, null, 8, ["isOpen", "notificationID"]))
      : _createCommentVNode("", true)
  ]))
}